import {default as i18n} from "i18next";

const $ = require("jquery");

import {sendGetRequest} from "./apiv4helper";
import {filterXSS} from "xss";

var actions = {
    default: '/admin/audit-log',
    billing: '/admin/audit-log/billing',
    seller: '/admin/audit-log/seller'
};

/**
 *
 * @param entityGetter function returning entity id
 * @param action API called
 * @constructor
 */
function AuditLog(entityGetter, action){
    i18n.init();

    this.entityGetter = entityGetter;
    // $('.billing-sellers').dropdown('get value')
    if (action in actions){
        this.action = actions[action];
    } else {
        throw "Audit type not supported";
    }

    this.toggleHistoryDiv = () => {
        let $history = $("#changeHistory");
        let $icon = $("#changeHistoryBtn").find("i");
        if ($history.is(':visible')) {
            $history.hide();
            $icon.removeClass("up");
            $icon.addClass("down");
        } else {
            try {
                let requestedEntityId = this.entityGetter();
                $history.show();
                $icon.removeClass("down");
                $icon.addClass("up");
                if (true || this.entity_id !== requestedEntityId) {
                    $history.html("wait for it");
                    this.entity_id = this.entityGetter();
                    this.loadHistory(this.entity_id);
                }
            } catch (e) {
                if (e !== "No auditLog needed") {
                    throw e;
                }
            }
        }
    };

    this.loadHistory = (entityId, page, limit) => {
        if (entityId===null) {
            entityId="";
        }
        //apiV4 call
        let req = sendGetRequest(this.action,
            {
                'entityId': entityId,
                'page': page,
                'limit': limit,
            });
        var $history = $("#changeHistory");
        req.done(data => {
            $history.html("");
            //let $sample = $("#history-sample-entry");
            this.sample = document.querySelector('#history-sample-entry');
            for(let i=0; i<data.length; i++){
                let entry = this.sample.cloneNode(true);
                for(let field_name in data[i]){
                    let el = this.getEntryElement(entry, this.getAlias(field_name));
                    if (el) {
                        let handler = this.fillers['_default_'];
                        if (field_name in this.fillers) {
                            handler = this.fillers[field_name];
                        }
                        handler(field_name, el, data[i]);
                    }
                }
                let el = this.getEntryElement(entry, 'time');
                if (el) {
                    this.fillers['time']('date', el, data[i]);
                }
                entry.removeAttribute("id");
                entry.removeAttribute("style");
                $history[0].appendChild(entry);
            }
        }).fail(function(jqXHR, textStatus) {
            $history.html("");
            alert(jqXHR.status + '\n' + jqXHR.statusText + '\n' + textStatus);
        });
    };

    this.getEntryElement = (entry, alias) => {
        return entry.querySelector('.entry-'+alias);
    };
    this.getAlias = (field_name) => {
        let aliases = {
            'username': 'user',
            'operation': 'function',
            'entity': 'model'
        };
        if (field_name in aliases) {
            return aliases[field_name];
        } else {
            return field_name;
        }
    };
    this.fillers = {
        '_default_': (field_name, el, data) => {
            let value = data[field_name];
            let html = value;
            el.innerHTML = html;
        },
        'original': (field_name, el, data) => {
            let value = data[field_name];
            let html = '';
            for (let key in value) {
                html += key + ": " + filterXSS(value[key]) + " <br/>\n";
            }
            el.innerHTML = html;
        },
        'change': (field_name, el, data) => {
            let tbody = el.querySelector('table').lastElementChild;
            let sample_row = tbody.firstElementChild;

            const parseData = data['change'].length === 0 && data['operation'] === 'DELETED' ? data['original'] : data['change'];
            for (let key in parseData) {
                let new_row = sample_row.cloneNode(true);
                new_row.querySelector('[data-label="Field"]').innerHTML = key;
                new_row.querySelector('[data-label="Old Value"]').innerHTML = filterXSS(data['original'][key]);
                new_row.querySelector('[data-label="New Value"]').innerHTML = filterXSS(data['change'][key]);
                tbody.append(new_row);
            }
            tbody.removeChild(sample_row);
        },
        'date': (field_name, el, data) => {
            let value = data[field_name].split(' ')[0];
            let html = value;
            el.innerHTML = html;
        },
        'time': (field_name, el, data) => {
            let value = data[field_name].split(' ')[1];
            let html = value;
            el.innerHTML = html;
        }
    };

    $('#changeHistoryBtn').on("click", this.toggleHistoryDiv);
}

export {AuditLog};